import React from "react";

import { useDeleteSuppressionDetailsItemMutation } from "@tiny/api";
import { DeleteSuppressionDetailsDialogProps } from "./DeleteSuppressionDetailsDialog";

export function useDeleteSuppressionDetailsDialog(
  props: DeleteSuppressionDetailsDialogProps
) {
  const { onSuccess, suppressions, suppressionId } = props;

  const {
    mutateAsync: deleteCustomerMutateAsync,
    isLoading: isDeleteCustomerLoading,
  } = useDeleteSuppressionDetailsItemMutation();

  const deleteSuppressions = React.useCallback(async () => {
    const ids = suppressions.map(({ id }) => id!);
    await deleteCustomerMutateAsync({
      suppressionId: suppressionId || "",
      data: { ids },
    });
    onSuccess();
  }, [suppressions, deleteCustomerMutateAsync, suppressionId]);

  const deleting = isDeleteCustomerLoading;

  return {
    deleteSuppressions,
    deleting,
  };
}
